import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Distribution, DistributionOverviewItem } from '../../models';
import { DistributionApiService } from './distribution.api.service';
import { StopDistributionReasonDto } from '../../models/stop-distribution-reason-dto';
import { TrackingData } from '../../models/tracking/tracking_data';

@Injectable()
export class DistributionDomainService {
    constructor(private distributionApiService: DistributionApiService) { }

    public getDistributionDetailById(id: string): Observable<Distribution> {
        return this.distributionApiService.getDistributionDetailById(id);
    }
    public getTrackingData(id: string): Observable<TrackingData> {
        return this.distributionApiService.getTrackingData(id);
    }

    public getDistributionOverviewByWeekNumber(weekNumber: number): Observable<DistributionOverviewItem[]> {
        return this.distributionApiService.getDistributionOverviewByWeekNumber(weekNumber);
    }

    public startDistribution(distributionId: string): Observable<any> {
        return this.distributionApiService.startDistribution(distributionId);
    }

    public stopDistribution(stopDistributionReasonDto: StopDistributionReasonDto): Observable<any> {
        return this.distributionApiService.stopDistribution(stopDistributionReasonDto);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/distribution/distribution.domain.service.ts